var map = {
	"./palette-au.json": "+ZOU",
	"./palette-ca.json": "nbOk",
	"./palette-cn.json": "R4pQ",
	"./palette-de.json": "O9WS",
	"./palette-defo.json": "w3am",
	"./palette-es.json": "AsUm",
	"./palette-fr.json": "nfn3",
	"./palette-gb.json": "cALD",
	"./palette-in.json": "na+P",
	"./palette-nl.json": "hiUQ",
	"./palette-ru.json": "Qmug",
	"./palette-se.json": "rLi2",
	"./palette-template.json": "9Gz+",
	"./palette-tr.json": "l/xk",
	"./palette-us.json": "SGCi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4VA";


//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/palette\-.*\.json$
// module id = e4VA
// module chunks = 1